function Header(props){
    return(

        <>
        <h1 className="text-4xl font-bold">Hello!{props.name}</h1>
          <p>I Help You Manage Your Activities :)</p>
        </>
    )
}
export default Header;